import { validateCpf } from '../cpf';
import { validateDocumentNumber } from '../document-number';

interface FormData {
  documentType?: string;
  documentNumber: string;
}

export const validateDocument = (
  formData: FormData,
  supportedCharacters?: string
): boolean => {
  if (!formData.documentNumber) {
    return false;
  }

  if (formData.documentType?.toLowerCase() === 'cpf') {
    return validateCpf(formData.documentNumber);
  }

  return validateDocumentNumber(formData.documentNumber, supportedCharacters);
};
